import React from "react";

const LoadingButton = props => {

    let loadingClass = props.loading ? "button--loading" : "button--loading--still";

    return (
        <button disabled={props.disabled} type={props.type} className={"button " + props.className + " " + loadingClass} onClick={e => {
            if (props.loading) {
                e.preventDefault();
            } else {
                if (props.onClick) props.onClick(e);
            }
        }}>
            {props.loading ? (props.progress ? `Uploading: ${props.progress}%` : <div className="spinner"></div>) : props.children}
        </button>
    )
}

export default LoadingButton;